module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point02-b1d2d267706389be0c0f18d753dbb01a.png";